import React from "react";
import ContextMenu from "../../ContextMenu";
import DocumentStore from "../../../document/DocumentStore";
import { COMMANDS } from "../../../document/commands";

const LayerPanelCanvasSetAreaMenu = ({ canvasSetBlockList, canvasSetId, siteBlocks, area }) => {
  const onBlockToggle = (blockId, inSiteCanvas) => {
    const data = { id: canvasSetId, blockId, area };
    inSiteCanvas
      ? DocumentStore.dispatch({ type: COMMANDS.REMOVE_CANVAS_FROM_CANVAS_SET, payload: data })
      : DocumentStore.dispatch({ type: COMMANDS.ADD_CANVAS_TO_CANVAS_SET, payload: data });
  };

  return (
    <ContextMenu
      placement="bottom"
      iconClasses="glyphicon glyphicon-plus"
      hiddenToStart={false}
      triggerPrefixClass="site-canvases"
    >
      <span className="label">Choose site canvases</span>
      {siteBlocks.map((block) => {
        const id = block.get("id");
        const name = block.get("name");
        const inCanvasSet = canvasSetBlockList.indexOf(id) !== -1;
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            key={id}
            className={`drop-down-button `}
            onClick={(e) => {
              e.stopPropagation();
              onBlockToggle(id, inCanvasSet);
            }}
          >
            <div className={`icon-${!inCanvasSet ? "un" : ""}checked`} />
            {name}
          </a>
        );
      })}
    </ContextMenu>
  );
};

export default LayerPanelCanvasSetAreaMenu;
